export const getDepth = (path) => {
  if (!path) return 1
  return path.split('[').join('.').split('.').length
}

export default getDepth
